/* theme: {                           Theme name  (default)
  'background-color': '#FEF0E5',      General background color
  'font-color': '#000',               General font color
  "font-url": 'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',  Font url
  'font-family': 'Barlow',            General font family
  primary: '#22142B',                 Primary color, when elements are active for example
  'font-color-primary': '#fff',       Font color for primary color
  secondary: '#22142B',               Secondary color, when elements are hovered
  'font-color-secondary': '#fff',     Font color for secondary color
  'border-color': '#22142B',          General border color
  "error-color": '#22142B',           Error color
}
*/

export default {
	default: {
		// 'background-color': '#FEF0E5',
		'background-color': '#Ffffff',
		'font-color': '#000',
		'font-url':
			'https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
		'font-family': 'Barlow',
		primary: '#22142B',
		'font-color-primary': '#fff',
		secondary: '#29083d',
		'font-color-secondary': '#fff',
		'border-color': '#22142B',
		'error-color': 'red'
	},
	green: {
		'background-color': '#656B47',
		'font-color': '#F0F1D8',
		'font-url':
			'https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
		'font-family': 'Barlow',
		primary: '#FFFFFF',
		'font-color-primary': '#656B47',
		secondary: '#F0F1D8',
		'font-color-secondary': '#656B47',
		'border-color': '#fff',
		'error-color': 'red'
	},
	blue: {
		'background-color': '#B4E2FC',
		'font-color': '#8296BB',
		'font-url':
			'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
		'font-family': 'Playfair Display',
		primary: '#8296BB',
		'font-color-primary': '#fff',
		secondary: '#FEEAB8',
		'font-color-secondary': '#8296BB',
		'border-color': '#8296BB',
		'error-color': 'red'
	}
};
